export const NATIVE_DATE_FORMAT = 'yyyy-mm-dd';
export const NORMALIZED_DATE_FORMAT = 'mm/dd/yyyy';

export const DateFieldConstants = {
  DaysUntilCoveredEndDateStart: 54,
  DaysUntilCoveredEndDateEnd: 168,
};
